/* eslint-disable react/no-children-prop */
import xLogo from '@/assets/images/pngs/x-logo.png';
import { STATE_AUTH_PARAMS } from '@/configs/constants';
import { ENV_CLIENT_ID } from '@/configs/environment';
import LoginService from '@/services/login-service';
import { t } from 'i18next';
interface TwitterButtonProps {
    state: string
}

const TwitterButton: React.FC<TwitterButtonProps> = ({ state }) => {
    const login = () => {
        const authUrl = LoginService.getTwitterAuthUrl(state);
        window.location.href = authUrl;
    };
    return (
        <div onClick={login} className='w-full h-[48px] rounded-full border-borderGray border-[1px] flex justify-center items-center cursor-pointer content-center'>
            <img src={xLogo} alt='xLogo' className='w-[24px] h-[24px]' />
            <p className='ml-[10px] text-[15px] text-text font-semibold'>{t('text.viaX')}</p>
        </div>
    );
};

export default TwitterButton;
